module.exports = __webpack_public_path__ + "img/versus-img.5b48be58.png";